import React from "react";
import { CustomSubHeader } from "../../../components/subheader";
import { SubheaderNav } from "../../../components/subheader/subheaderNav";

export default function WalletHistorySubheader({ tabName, children }) {
    const links = [
        { name: "Global Transactions", to: "/wallet-history/transactions", icon: "bi bi-globe" },
        { name: "Global Imp Transactions", to: "/wallet-history/imp-transactions", icon: "bi bi-ui-radios-grid" },
        { name: "Global Transactions Summary", to: "/wallet-history/summary", icon: "bi bi-calendar-day" },
    ];
    return (
        <CustomSubHeader>
            <div className="w-100 d-flex flex-stack">
                <SubheaderNav links={links} active={tabName} />
                <div>
                    {children}
                </div>
            </div>
        </CustomSubHeader>
    );
}
